var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{triggered: _vm.triggered, restored: _vm.restored},on:{"click":function($event){$event.preventDefault();return _vm.onClicked.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }